<template>
  <ModalDialog
    ref="dialog"
    title="Add Panels"
    icon="fa-layer-group"
    sizeClass="modal-med"
    :showFooter="true"
    closeTitle="Cancel"
    submitTitle="Add"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="form" :labelColumnSize="3">
      <LoadingPanel :loading="loadingStock" :loadingError="loadingStockError" />
      <div v-if="!loadingStock && !loadingStockError">
        <h3>{{infoTitle}}</h3>
        <FormHorizontalRule />
        
        <FormRow label="Create new sheets" helpTip="If set, will create more sheets into the job queue to ensure all selected panels are allocated into the job queue">
          <FormSwitch booleanMode v-model="autoAddOptions.createNewSheets" />
        </FormRow>
        <div v-show="autoAddOptions.createNewSheets">
          <FormHorizontalRule />
          <ContentTitle>New Sheet Details</ContentTitle>
          <ContentSubTitle>Options for any new sheets required</ContentSubTitle>
          <FormRow label="Sheet Size">
            <FormSelect :options="glassLevelOptions" v-model="autoAddOptions.glassLevelId" field="glassLevelId" placeholder="Sheet Size"></FormSelect>
          </FormRow>

          <FormRow label="Top Trim">
            <FormInputText type="number" addon="mm" v-model="autoAddOptions.trimTop" field="trimTop" />
          </FormRow>
          <FormRow label="Right Trim">
            <FormInputText type="number" addon="mm" v-model="autoAddOptions.trimRight" field="trimRight" />
          </FormRow>
          <FormRow label="Bottom Trim">
            <FormInputText type="number" addon="mm" v-model="autoAddOptions.trimBottom" field="trimBottom" />
          </FormRow>
          <FormRow label="Left Trim">
            <FormInputText type="number" addon="mm" v-model="autoAddOptions.trimLeft" field="trimLeft" />
          </FormRow>
        </div>
      </div>

    </FormGroup>
  </ModalDialog>
</template>

<style scoped>

</style>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'OptimiserAutoAddPanelDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    panelCount: Number,
    stockId: Number
  },
  data() {
    return {
      form: {},
      autoAddOptions: {
        createNewSheets: false,
        glassLevelId: 0,
        trimTop: 0,
        trimRight: 0,
        trimBottom: 0,
        trimLeft: 0
      },
      loadingStock: false,
      loadingStockError: '',
      glassLevelLookup: []
    }
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  computed: {
    infoTitle() {
      return `Adding ${this.panelCount} panel${this.displayCountPlural(this.panelCount)} to the current sheet`
    },
    glassLevelOptions() {
      return _.concat([{ value: 0, name: 'Any' }], this.glassLevelLookup)
    }
  },
  methods: {
    show(params) {
      this.form = {}
      this.submitting = false

      this.requestData()

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.form = this.clearFormResponse()

      this.modalClosed(this.autoAddOptions)
      this.hide()
    },
    requestData() {
      this.loadingStock = true
      this.$apiService.inventoryService.getStock(this.stockId)
      .then(response => {
        this.glassLevelLookup = []
        this.glassLevelLookup = _.concat(this.glassLevelLookup, response.data.glassSizeList.reduce((list, glassSize) => {
          if(!glassSize.isActive || glassSize.glassLevels.length == 0)
            return list

          list.push({
            name: `${glassSize.height}x${glassSize.width}`,
            children: glassSize.glassLevels.filter(glassLevel => glassLevel.isActive && !glassLevel.isOffcut).map(glassLevel => {
              let levelName = `${glassLevel.height}x${glassLevel.width}`
              levelName += ` - ${glassLevel.qtyOnHand} Sheets`

              return {
                value: glassLevel.id,
                name: levelName,
                width: glassLevel.width,
                height: glassLevel.height,
                isOffcut: glassLevel.isOffcut,
                barcode: glassLevel.barcode
              }
            })
          })
          return list
        }, []))
      })
      .catch(err => {
        console.error(err)
        this.loadingStockError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loadingStock = false
      })
    }
  }
}
</script>